import gql from "graphql-tag";

export const GetSendbirdInfo = gql`
  query GetOrganizationInfo {
    accounts {
      id
      sendbirdToken
    }
  }
`;